import { PropsWithChildren, useState } from 'react';
import createSafeContext from '@paradigm/utils/src/createSafeContext';

export type TabId =
  | 'volume'
  | 'liquidity'
  | 'liquidity-fills'
  | 'liquidity-responses';

interface View {
  readonly activeTab: TabId;
}

interface Actions {
  readonly setActiveTab: (tabId: TabId) => void;
}

const [useViewCtx, ViewCtxProvider] = createSafeContext<View>(
  'LeaderboardTabsView',
);

const [useActionsCtx, ActionsCtxProvider] = createSafeContext<Actions>(
  'LeaderboardTabsActions',
);

export const useLeaderboardTabsView = useViewCtx;
export const useLeaderboardTabsActions = useActionsCtx;

export default function LeaderboardTabsProvider({
  children,
}: PropsWithChildren<object>) {
  const [activeTab, setActiveTab] = useState<TabId>('volume');

  const view = { activeTab };
  const actions = {
    setActiveTab: (newTab: TabId) => {
      // Update to inner tab when going to liquidity tab
      if (newTab === 'liquidity') {
        setActiveTab('liquidity-fills');
        return;
      }
      setActiveTab(newTab);
    },
  };

  return (
    <ViewCtxProvider value={view}>
      <ActionsCtxProvider value={actions}>{children}</ActionsCtxProvider>
    </ViewCtxProvider>
  );
}
